import { EventType } from "../components/types";

export class NavigationHelpers {
  static jumpToContentView(): void {
    const contentViewElement = document.getElementById("content-view");
    if (contentViewElement) {
      contentViewElement.scrollIntoView();
      window.scrollBy(0, -150);
    }
  }

  static getNavigateToRootState() {
    return {
      selectedEvent: null,
      selectedAlbum: null,
      selectedFolderData: null,
      selectedFolderId: null,
      openedEventInstances: new Set(),
      encodedString: "",
      photoCurrentPage: 1
    };
  }

  static getNavigateToAlbumState(selectedEvent: EventType) {
    return {
      selectedAlbum: null,
      selectedEvent: selectedEvent,
      photoCurrentPage: 1
    };
  }

  static getNavigateToEventsState() {
    return {
      selectedAlbum: null,
      selectedEvent: null,
      photoCurrentPage: 1
    };
  }
}
